import { motion } from "framer-motion";
import { Coins, Home, Vote, Gift, Repeat, Scroll } from "lucide-react";
import { BENEFITS, BENEFITS_INTRO } from "@/data/content";
import { useT } from "@/i18n/LanguageContext";

const ICONS = { Coins, Home, Vote, Gift, Repeat, Scroll };

export const Benefits = () => {
  const t = useT();

  return (
    <section id="token" data-testid="benefits-section" className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <span className="uppercase text-xs tracking-[0.25em] text-[#1A1A1F] font-bold">
            {t(BENEFITS_INTRO.eyebrow)}
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight mt-4">
            {t(BENEFITS_INTRO.title)}
          </h2>
          <p className="text-[#62646B] leading-relaxed mt-6">{t(BENEFITS_INTRO.description)}</p>
        </motion.div>

        <div data-testid="benefits-grid" className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
          {BENEFITS.map((b, i) => {
            const Icon = ICONS[b.icon];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.1 }}
                data-testid={`benefit-card-${i}`}
                className="p-8 rounded-3xl bg-white border border-[#E8E7E2] hover:border-[#0A0A0F]/30 hover:-translate-y-1 transition-all duration-300 group"
              >
                <div className="w-12 h-12 rounded-2xl border border-[#E8E7E2] flex items-center justify-center bg-[#FAFAF7] group-hover:border-[#0A0A0F]/30 transition-colors duration-300">
                  {Icon && <Icon size={22} className="text-[#1A1A1F]" />}
                </div>
                <h3 className="font-heading text-xl font-medium mt-6">{t(b.title)}</h3>
                <p className="text-sm text-[#62646B] mt-3 leading-relaxed">{t(b.desc)}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
